<template>
      <v-card color="rgba(170,170,170,0.4)" height="100%" width="100%" tile>
          <v-card-title>
              {{dados.dados.nome}}
          </v-card-title>
          <v-card-subtitle>
              {{dados.dados.email}}<br />
              {{dados.dados.grauAtual}}º grau - {{dados.dados.claAtual}}
          </v-card-subtitle>
          <v-divider></v-divider>
          <v-card-text class="ma-4 pa-4">
            <v-row>
                <v-col class="" cols="4">
                    <span class="body-1">Data de Nascimento:</span>
                    <span class="body-2"> {{dados.dados.dtNascimento.toLocaleDateString('pt-BR')}}</span>
                </v-col>
                <v-col class="" cols="4">
                    <span class="body-1">Hora do Nascimento:</span>
                    <span class="body-2"> {{dados.dados.hrNascimento.toLocaleTimeString('pt-BR')}}</span>
                </v-col>
                <v-col class="" cols="4">
                    <span class="body-1">Data da Iniciação:</span>
                    <span class="body-2"> {{dados.dados.dtIniciacao.toLocaleDateString('pt-BR')}}</span>
                </v-col>
            </v-row>
            
            <v-row>
                <v-col class="" cols="4">
                    <span class="body-1">RG:</span>
                    <span class="body-2"> {{dados.outros.rg}}</span>
                </v-col>
                <v-col class="" cols="4">
                    <span class="body-1">CPF:</span>
                    <span class="body-2"> {{dados.outros.cpf}}</span>
                </v-col>
                <v-col class="" cols="4">
                    <span class="body-1">Celular:</span>
                    <span class="body-2"> {{dados.residencial.celular}}</span>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="" cols="12">
                    <span class="body-1">Endereço Residencial:</span>
                    <span class="body-2"> {{dados.residencial.rua}}, {{dados.residencial.numero}} - {{dados.residencial.compl}} - {{dados.residencial.bairro}} - {{dados.residencial.cidade}} - {{dados.residencial.estado}} - {{dados.residencial.nomePais}} -- Cep: {{dados.residencial.cep}}</span>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="" cols="4">
                    <span class="body-1">Profissão:</span>
                    <span class="body-2"> {{dados.outros.profissao}}</span>
                </v-col>
                <v-col class="" cols="4">
                    <span class="body-1">Grau de Instrução:</span>
                    <span class="body-2"> {{dados.outros.grauInstrucao}}</span>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="" cols="4">
                    <span class="body-1">Status:</span>
                    <span class="body-2"> {{dados.outros.status}}</span>
                </v-col>
                <v-col class="" cols="4">
                    <span class="body-1">Perfil:</span>
                    <span class="body-2"> {{dados.outros.perfil}}</span>
                </v-col>
            </v-row>
          </v-card-text>
      </v-card>
</template>

<script>
export default {
props:['dados'],
}
</script>

<style scoped>

</style>